import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import { isAdmin, isEstablishment } from "./config/auth";

//Pages
// ----- Admin -----

import Dashboard from "./pages/_admin/Dashboard";
import Store from "./pages/_admin/Store";
import Invoice from "./pages/_admin/Invoice";
import Team from "./pages/_admin/Team";
import AdminProduct from "./pages/_admin/Product";
import ReserveCompleted from "./pages/_admin/ReserveCompleted";
import SingleStore from "./pages/_admin/SingleStore";
import SingleClient from "./pages/_admin/SingleClient";
import Client from "./pages/_admin/Client";

// ----- User -----
import DashboardUser from "./pages/_user/Dashboard";
import Product from "./pages/_user/Product";
import BeautyProduct from "./pages/_user/Product/Beauty";
import RecreationProduct from "./pages/_user/Product/Recreation";
import DrugStoreProduct from "./pages/_user/Product/DrugStore";
import Chat from "./pages/_user/Chat";
import StoreInfos from "./pages/_user/StoreInfos";
import Reserve from "./pages/_user/Reserve";
import BeautyReserve from "./pages/_user/Reserve/Beauty";
import RecreationReserve from "./pages/_user/Reserve/Recreation";
import DrugStoreReserve from "./pages/_user/Reserve/DrugStore";
import ProductVariation from "./pages/_user/ProductVariation";
import Category from "./pages/_user/Category";

// Profile
import Profile from "./pages/Profile";

// Auth
import ChangePassword from "./pages/auth/ChangePassword";
import CreateAccount from "./pages/CreateAccount";
import ForgotPassword from "./pages/auth/ForgotPassword";
import Login from "./pages/auth/Login";

// Others

import NotFound from "./pages/others/NotFound";
import Collaborators from "./pages/_user/Collaborators";
import { useAuth } from "./context/ContextApi";
import Collaborator from "./pages/_user/Collaborator";
import Preference from "./pages/_admin/Preference";
import PrivacyPolicy from "./pages/auth/PrivacyPolicy";
import EmailValidation from "./pages/auth/EmailValidation";
import ChangePasswordMobile from "./pages/auth/ChangePasswordMobile";
import SuccessPassword from "./pages/auth/SuccessPassword";

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAdmin() ? <Component {...props} /> : <Redirect to={{ pathname: "/", state: { from: props.location } }} />
    }
  />
);

const EstablishmentRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isEstablishment() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const Routes = () => {
  const { isBeautyEstablishment, isRecreationEstablishment, isDrugStoreEstablishment } = useAuth();

  const ProductsRoute = () => {
    if (isAdmin()) {
      return <AdminProduct />;
    } else if (isEstablishment()) {
      if (isBeautyEstablishment) {
        return <BeautyProduct />;
      } else if (isRecreationEstablishment) {
        return <RecreationProduct />;
      } else if (isDrugStoreEstablishment) {
        return <DrugStoreProduct />;
      } else {
        return <Product />;
      }
    } else {
      return <Redirect to={{ pathname: "/" }} />;
    }
  };
  const ReservesRoute = () => {
    if (isEstablishment()) {
      if (isBeautyEstablishment) {
        return <BeautyReserve />;
      } else if (isRecreationEstablishment) {
        return <RecreationReserve />;
      } else if (isDrugStoreEstablishment) {
        return <DrugStoreReserve />;
      } else {
        return <Reserve />;
      }
    } else {
      return <Redirect to={{ pathname: "/" }} />;
    }
  };
  return (
    <BrowserRouter>
      <Switch>
        {/* Dynamic Routes */}
        <Route exact path="/produtos" component={ProductsRoute} />
        <Route exact path="/reservas/:id" component={ReservesRoute} />

        {/* Admin */}
        <AdminRoute path="/dashboard" component={Dashboard} />
        <AdminRoute path="/estabelecimentos" component={Store} />
        <AdminRoute path="/faturas" component={Invoice} />
        <AdminRoute path="/clientes" component={Client} />
        <AdminRoute path="/cliente/:id" component={SingleClient} />
        <AdminRoute path="/preferencias" component={Preference} />

        <Route exact path="/time" component={Team} />

        <AdminRoute exact path="/reservas-concluidas" component={ReserveCompleted} />
        <AdminRoute exact path="/estabelecimento/:id" component={SingleStore} />

        {/* Establishment */}
        <EstablishmentRoute exact path="/dashboard-user" component={DashboardUser} />

        <EstablishmentRoute exact path="/chat/:id" component={Chat} />
        <EstablishmentRoute exact path="/dados-da-loja" component={StoreInfos} />

        <EstablishmentRoute exact path="/colaboradores" component={Collaborators} />
        <EstablishmentRoute exact path="/colaboradores/:id" component={Collaborator} />
        <EstablishmentRoute exact path="/variacao-produto" component={ProductVariation} />
        <EstablishmentRoute exact path="/categories-user" component={Category} />

        <Route exact path="/perfil" component={Profile} />

        {/* Auth */}
        <Route exact path="/alterar-senha/:token" component={ChangePassword} />
        <Route exact path="/alterar-senha-mobile/:token" component={ChangePasswordMobile} />
        <Route exact path="/alterar-senha-mobile-success/" component={SuccessPassword} />
        <Route exact path="/esqueci-minha-senha" component={ForgotPassword} />
        <Route exact path="/criar-conta" component={CreateAccount} />
        <Route exact path="/" component={Login} />
        <Route exact path="/privacy-policy" component={PrivacyPolicy} />
        <Route exact path="/email-validation/:id" component={EmailValidation} />

        {/* Others */}
        <Route path="*" component={NotFound} />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
